export const DEFAULT_ACCOUNTANT_EMAIL = "quickbooks-accountant@simplyinsured.com";

export const intuitBaseUrl = "/intuit/router";
export const intuitErrorUrl = "/intuit/quickbooks-error-page";
export const intuitAddAccountantUrl = "https://qbo.intuit.com/app/my-accountant";

export const isAnIntuitError = () => window.location.pathname.indexOf(intuitErrorUrl) !== -1;
